export default __webpack_public_path__ + "static/pic6-397b37d9260b1c579f32dcdf458ab2c0.png";